/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import { MdOutlineCancel } from 'react-icons/md';
import { useParams, useNavigate } from 'react-router-dom';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import {
  getFlightTicketApi,
  getCancelRefundApi,
  cancelFlightBookingApi,
  performSplitPnr,
} from '../../api/flightApi';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import './FlightReshedulePage.scss';
import {
  NAVIGATION_ROUTES,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  STATUS,
} from '../../shared/constants/Constants';
import {
  formatCurrency,
  formatDate,
  formatTimeString,
  getNewDate,
  isEmpty,
} from '../../shared/helper-utils/appUtils';
import AppButton from '../../shared/components/app-button/AppButton';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import { getUserDetails } from '../../api/profileApi';

function FlightCancellation() {
  const { transactionId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const flightTransactionRef = useRef(undefined);
  const flightRecordRef = useRef(undefined);
  const bookingInfoRef = useRef({});
  const flightSectorsRef = useRef(null);
  const passengerRef = useRef(null);
  const fareSummaryRef = useRef({});
  const [passengers, setPassengers] = useState({});
  const [hasTicket, setHasTicket] = useState(undefined);
  const [showCancelConfirmModal, setShowCancelConfirmModal] = useState(false);
  const [showPartialCancelFooter, setShowPartialCancelFooter] = useState(false);
  const cancellationRefundAmountRef = useRef(0);
  const apiCanxChargesRef = useRef(0);
  const totalCanxChargesRef = useRef(0);
  const totalRefunddAmountRef = useRef(0);
  const totalPartialCancelAmountRef = useRef(0);
  const onwardPaxRef = useRef([]);
  const returnPaxRef = useRef([]);
  const [selectedForCancel, setSelectedForCancel] = useState([]);
  const [cancelRemarks, setCancelRemarks] = useState('');
  const [requesterName, setRequesterName] = useState('');
  const [requestContactNumber, setRequestContactNumber] = useState('');
  const [showSplitPnrModal, setShowSplitPnrModal] = useState(false);
  const [showConfirmOfflineCancelPopup, setShowConfirmOfflineCancelPopup] =
    useState(false);

  const getFlightTicketRoute = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };

  const setFareSummary = (data) => {
    const fareDetails = data.FlightRecord.FareDetails.split('##').map(Number);
    [fareSummaryRef.current.basefare, fareSummaryRef.current.totaltaxes] =
      fareDetails;
    fareSummaryRef.current.gst = fareDetails[3];
    const ssrAmount = data.FlightRecord.SSRAmount;
    const totalAmount =
      fareDetails[0] + fareDetails[1] + fareDetails[3] + ssrAmount;
    fareSummaryRef.current.invoicetotal = totalAmount;
    fareSummaryRef.current.ssr = ssrAmount;
  };
  useEffect(() => {
    const fetchUserDetails = async () => {
      const res = await getUserDetails(getUserAgentId());
      if (res && res.ApiStatus?.Status === 'OK') {
        const { User } = res.ApiStatus.Result;
        if (!isEmpty(User)) {
          const fullName = `${User.FirstName || ''} ${
            User.LastName || ''
          }`.trim();
          setRequesterName(fullName);
          let mobile = User.MobileNumber;
          if (mobile?.toString()?.indexOf('-') > -1) {
            mobile = mobile?.toString()?.split('-')[1];
          }
          setRequestContactNumber(mobile || '');
        }
      }
    };

    fetchUserDetails();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    const response = await getFlightTicketApi(transactionId, getUserAgentId());
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      const { FlightInvoice } = response.ApiStatus.Result.FullFlightDetails;
      flightTransactionRef.current = FlightInvoice;
      flightRecordRef.current = FlightInvoice.FlightRecord;
      bookingInfoRef.current = {
        AirlinePnr: FlightInvoice.FlightRecord.AirlinePnr,
        BookingStatus: FlightInvoice.FlightRecord.BookingStatus,
        Origin: FlightInvoice.FlightRecord.Origin,
        Destination: FlightInvoice.FlightRecord.Destination,
        Jtype: FlightInvoice.FlightRecord.JType.toLowerCase(),
      };
      let { SectorRecord } = FlightInvoice.SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];

      const airportNames = {};
      SectorRecord.forEach((ele) => {
        airportNames[ele.Origin] = ele.OriginFullName;
        airportNames[ele.Destination] = ele.DestinationFullName;
      });
      flightSectorsRef.current = SectorRecord;

      let { PassengerRecord } = FlightInvoice.PassengerRecords;
      PassengerRecord = Array.isArray(PassengerRecord)
        ? PassengerRecord
        : [PassengerRecord];

      passengerRef.current = PassengerRecord;

      let onwardList = [];
      onwardList = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 1,
      );
      onwardPaxRef.current = onwardList;

      let returnList = [];
      returnList = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 2,
      );
      returnPaxRef.current = returnList;

      const list = { ...passengerRef.current };
      setPassengers(list);
      setFareSummary(FlightInvoice);
      setHasTicket(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [transactionId]);

  const handleCheckboxSelection = (pax) => {
    if (
      pax.Type.toLowerCase() === 'adult' ||
      pax.Type.toLowerCase() === 'infant'
    ) {
      const infantList = [];
      const adultList = [];

      if (pax.SegmentNumber === 1) {
        onwardPaxRef.current.forEach((passenger) => {
          if (passenger.Type.toLowerCase() === 'adult') {
            adultList.push(passenger.Paxid);
          }
          if (passenger.Type.toLowerCase() === 'infant') {
            infantList.push(passenger.Paxid);
          }
        });
      }

      if (pax.SegmentNumber === 2) {
        returnPaxRef.current.forEach((passenger) => {
          if (passenger.Type.toLowerCase() === 'adult') {
            adultList.push(passenger.Paxid);
          }
          if (passenger.Type.toLowerCase() === 'infant') {
            infantList.push(passenger.Paxid);
          }
        });
      }

      if (infantList.length > 0) {
        const paxTobeSelected = [pax];
        if (pax.Type.toLowerCase() === 'infant') {
          const selectedIndex = infantList.indexOf(pax.Paxid);
          const paxAssociated = passengerRef.current.find(
            (px) => px.Paxid === adultList[selectedIndex],
          );
          if (paxAssociated) {
            paxTobeSelected.push(paxAssociated);
          }
        }

        if (pax.Type.toLowerCase() === 'adult') {
          const selectedIndex = adultList.indexOf(pax.Paxid);
          const paxAssociated = passengerRef.current.find(
            (px) => px.Paxid === infantList[selectedIndex],
          );
          if (paxAssociated) {
            paxTobeSelected.push(paxAssociated);
          }
        }

        let list = [...selectedForCancel];
        paxTobeSelected.forEach((x) => {
          if (list.some((item) => item.Paxid === x.Paxid)) {
            list = list.filter((p) => p.Paxid !== x.Paxid);
          } else {
            list.push(x);
          }
        });

        setSelectedForCancel(list);
        return;
      }
    }

    setSelectedForCancel((prevItems) => {
      if (prevItems.some((selectedPax) => selectedPax.Paxid === pax.Paxid)) {
        return prevItems.filter(
          (selectedPax) => selectedPax.Paxid !== pax.Paxid,
        );
      }
      return [...prevItems, pax];
    });
  };

  const handleConfirmCancel = async () => {
    setIsLoading(true);
    let cancellationType = 'full';
    const cancelledPax = [];
    selectedForCancel.forEach((pax) => {
      cancelledPax.push({
        paxid: pax.Paxid,
        tripnumber: pax.SegmentNumber,
      });
    });
    const confirmedPax = passengerRef.current.filter(
      (pax) => pax.Status.toLowerCase() === 'confirmed',
    );
    if (cancelledPax.length !== confirmedPax.length) {
      cancellationType = 'partial';
    }
    if (confirmedPax.length < passengerRef.current.length) {
      cancellationType = 'partial';
    }
    const agentId = getUserAgentId();
    const response = await cancelFlightBookingApi(
      agentId,
      transactionId,
      cancellationType,
      cancelledPax,
      cancelRemarks,
      requesterName,
      requestContactNumber,
    );
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Cancel Flight',
        description: `${response.ApiStatus.Message}, Redirecting to My bookings`,
      });
      setTimeout(() => {
        navigate('/my-bookings?transactionType=flightcancellationsqueues');
      }, 2000);
    } else {
      setAlert({
        variant: 'error',
        title: 'Cancel Flight',
        description: response?.ApiStatus?.Message || 'Failed to cancel flight',
      });
    }
    setShowCancelConfirmModal(false);
    setIsLoading(false);
  };

  const handleCancel = async () => {
    let onwardCount = 0;
    let returnCount = 0;
    selectedForCancel.forEach((pax) => {
      if (pax.SegmentNumber === 1) {
        onwardCount += 1;
      }
      if (pax.SegmentNumber === 2) {
        returnCount += 1;
      }
    });
    const confirmedOnwardPax = passengerRef.current.filter(
      (pax) =>
        pax.Status.toLowerCase() === 'confirmed' && pax.SegmentNumber === 1,
    );
    const confirmedPax = passengerRef.current.filter(
      (pax) => pax.Status.toLowerCase() === 'confirmed',
    );
    const confirmedReturnPax = passengerRef.current.filter(
      (pax) =>
        pax.Status.toLowerCase() === 'confirmed' && pax.SegmentNumber === 2,
    );
    if (bookingInfoRef.current.Jtype.toLowerCase() === 'oneway') {
      if (onwardCount !== confirmedOnwardPax.length) {
        setShowSplitPnrModal(true);
        return;
      }
    }
    if (bookingInfoRef.current.Jtype.toLowerCase() !== 'oneway') {
      if (onwardCount > 0 && onwardCount !== confirmedOnwardPax.length) {
        setShowSplitPnrModal(true);
        return;
      }
      if (returnCount > 0 && returnCount !== confirmedReturnPax.length) {
        setShowSplitPnrModal(true);
        return;
      }
    }
    let tripType = 'onward';
    if (onwardCount === 0 && returnCount > 0) {
      tripType = 'return';
    }
    if (onwardCount + returnCount === confirmedPax.length) {
      tripType = 'all';
    }
    if (confirmedPax.length < passengerRef.current.length) {
      tripType = 'partial';
    }
    setIsLoading(true);
    const response = await getCancelRefundApi(transactionId, tripType);
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      const { Result } = response.ApiStatus;
      if (!isEmpty(Result)) {
        const {
          apicanxcharges,
          totalcanxcharges,
          finalrefundamount,
          otacanxcharges,
        } = Result;
        apiCanxChargesRef.current = apicanxcharges;
        totalCanxChargesRef.current = totalcanxcharges;
        cancellationRefundAmountRef.current = finalrefundamount;
        totalRefunddAmountRef.current = otacanxcharges;
        setShowCancelConfirmModal(true);
      } else {
        setAlert({
          title: 'Cancel Flight',
          variant: 'error',
          description:
            response?.ApiStatus?.Message ||
            'Failed to fetch cancellation charges',
        });
      }
    } else {
      setAlert({
        title: 'Cancel Flight',
        variant: 'error',
        description: response?.ApiStatus?.Message || 'Failed to cancel',
      });
    }
    setIsLoading(false);
  };

  const handlePartialCancellation = async () => {
    setShowSplitPnrModal(false);
    setIsLoading(true);
    const agentId = getUserAgentId();
    const cancelledPax = [];
    selectedForCancel.forEach((pax) => {
      cancelledPax.push({
        paxid: pax.Paxid,
        tripnumber: pax.SegmentNumber,
      });
    });
    const response = await cancelFlightBookingApi(
      agentId,
      transactionId,
      'partial',
      cancelledPax,
      cancelRemarks,
      requesterName,
      requestContactNumber,
    );
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Cancel Flight',
        description: `${response?.ApiStatus?.Message}, Redirecting to My bookings`,
      });
      setTimeout(() => {
        navigate('/my-bookings?transactionType=flightcancellations');
      }, 2000);
    } else {
      setAlert({
        variant: 'error',
        title: 'Cancel Flight',
        description: response?.ApiStatus?.Message || 'Failed to cancel flight',
      });
    }
    setIsLoading(false);
  };

  const handleSplitPnr = async () => {
    setIsLoading(true);
    const cancelledPax = [];
    selectedForCancel.forEach((pax) => {
      cancelledPax.push({
        paxid: pax.Paxid,
        tripnumber: pax.SegmentNumber,
      });
    });
    const response = await performSplitPnr(cancelledPax, transactionId);
    if (response && response?.ApiStatus?.Status === 'OK') {
      const { Result } = response.ApiStatus;
      if (Result === 'NODIVIDEPNR') {
        await handlePartialCancellation();
      } else {
        setAlert({
          title: 'Split PNR',
          variant: 'success',
          description:
            'Split PNR succesfull, navigating to the cancellation page',
        });
        navigate(`/flight/cancellation/${Result}`);
        window.location.reload();
      }
    } else {
      setAlert({
        title: 'Split PNR',
        variant: 'error',
        description: response?.ApiStatus?.Message
          ? response?.ApiStatus?.Message
          : 'Failed To split pnr',
      });
    }
    setIsLoading(false);
  };

  const isChecked = (id) => {
    const isPresent = selectedForCancel.some((x) => x.Paxid === id);
    if (isPresent) {
      return true;
    }
    return false;
  };

  const handleOfflineCancelRequest = () => {
    let onwardCount = 0;
    let returnCount = 0;
    selectedForCancel.forEach((pax) => {
      if (pax.SegmentNumber === 1) {
        onwardCount += 1;
      }
      if (pax.SegmentNumber === 2) {
        returnCount += 1;
      }
    });
    const confirmedPax = passengerRef.current.filter(
      (pax) => pax.Status.toLowerCase() === 'confirmed',
    );
    if (onwardCount + returnCount !== confirmedPax.length) {
      setShowSplitPnrModal(true);
      return;
    }
    setShowConfirmOfflineCancelPopup(true);
  };

  return (
    <section className="flight-reshedule-page">
      {alert && (
        <AppAlert
          variant={alert.variant}
          showIcon
          title={alert.title}
          description={alert.description}
        />
      )}
      <AppLoading isLoading={isLoading} />

      {hasTicket !== undefined && hasTicket && (
        <div className="flight-reshedule-page_container">
          <div className="flight-details">
            <h4>Flight Details</h4>
            <div className="flight-details-table overflow-auto">
              <table cellSpacing="4" cellPadding="5" className="w-100">
                <tbody>
                  <tr>
                    <td>Airline PNR</td>
                    <td>{flightRecordRef.current.AirlinePnr.split(',')[0]}</td>
                    <td>Booking Date</td>
                    <td>{flightRecordRef.current.BookingDate}</td>
                  </tr>
                  <tr>
                    <td>Booking Id</td>
                    <td>
                      <a
                        href={getFlightTicketRoute(
                          flightRecordRef.current.Txid,
                        )}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {flightRecordRef.current.Txid}
                      </a>
                    </td>
                    <td>Passenger Contact</td>
                    <td>{flightRecordRef.current.PassengerContact}</td>
                  </tr>
                  <tr>
                    <td>Booking Status</td>
                    <td>{flightRecordRef.current.BookingStatus}</td>
                    <td>GDS PNR</td>
                    <td>{flightRecordRef.current.GdsPnr}</td>
                  </tr>
                </tbody>
              </table>
              <table className="w-100">
                <thead>
                  <tr>
                    <th>From - To</th>
                    <th>Flight</th>
                    <th>Departure Date</th>
                    <th>Departure</th>
                    <th>Arrival</th>
                  </tr>
                </thead>
                <tbody>
                  {flightSectorsRef.current.map((sector) => (
                    <React.Fragment
                      key={`${sector.Origin}:${sector.Destination}`}
                    >
                      <tr>
                        <td>
                          {sector.OriginFullName}({sector.Origin}) --&gt;{' '}
                          {sector.DestinationFullName}({sector.Destination})
                        </td>
                        <td>
                          {sector.Carrier} - {sector.FlightNumber}(class-
                          {sector.BookingClass})
                        </td>
                        <td>
                          {formatDate(
                            getNewDate(sector.JourneyDate),
                            DATE_MONTH_YEAR_VIEW_FORMAT,
                          )}
                        </td>
                        <td>{formatTimeString(sector.DepartureTime)}</td>
                        <td>{formatTimeString(sector.ArrivalTime)}</td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
              <table className="w-100">
                <thead>
                  <tr>
                    <th>Fare</th>
                    <th>Tax</th>
                    <th>SSR</th>
                    <th>GST</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {fareSummaryRef.current.basefare !== null &&
                        fareSummaryRef.current.basefare.toFixed(2)}
                    </td>
                    <td>{fareSummaryRef.current.totaltaxes.toFixed(2)}</td>
                    <td>{fareSummaryRef.current.ssr.toFixed(2)}</td>
                    <td>{fareSummaryRef.current.gst.toFixed(2)}</td>
                    <td>{fareSummaryRef.current.invoicetotal.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
              <h6>Ticket Details</h6>
              <table className="w-100">
                <thead>
                  <tr>
                    <th>Tx.Id</th>
                    <th>Journey Type</th>
                    <th>Booking Date</th>
                    <th>Agent ID</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{flightRecordRef.current.Txid}</td>
                    <td>{flightRecordRef.current.JType}</td>
                    <td>{flightRecordRef.current.BookingDate}</td>
                    <td>
                      {flightRecordRef.current.AgentCompany}(
                      {flightRecordRef.current.AgentId})
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="cancel-pax_table p-3">
            {onwardPaxRef.current.length > 0 && (
              <div className="d-flex flex-column align-items-start">
                <span className="cancel-pax_sector-heading">
                  Select Passengers For Cancellation - Onward Journey. (
                  {flightRecordRef.current.Origin}-
                  {flightRecordRef.current.Destination})
                </span>
                <div className="d-flex flex-column m-2 fs-14 fw-500">
                  {onwardPaxRef.current.map((pax) => (
                    <div key={pax.Paxid} className="d-flex gap-2 my-1">
                      <span>
                        {pax.Status === 'confirmed' ||
                        pax.Status === 'rescheduled' ? (
                          <input
                            type="checkbox"
                            name={pax.Paxid}
                            value={pax.Paxid}
                            checked={isChecked(pax.Paxid)}
                            onChange={() => handleCheckboxSelection(pax)}
                          />
                        ) : (
                          '-'
                        )}
                      </span>
                      <span>
                        {pax.Title} {pax.FirstName} {pax.LastName}({pax.Type})
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {returnPaxRef.current.length > 0 && (
              <div className="mt-2 d-flex flex-column align-items-start">
                <span className="cancel-pax_sector-heading">
                  Select Passengers For Cancellation - Return Journey. (
                  {flightRecordRef.current.Destination}-
                  {flightRecordRef.current.Origin})
                </span>
                <div className="d-flex flex-column m-2 fs-14 fw-500">
                  {returnPaxRef.current.map((pax) => (
                    <div key={pax.Paxid} className="d-flex gap-2 my-1">
                      <span>
                        {pax.Status === 'confirmed' ||
                        pax.Status === 'rescheduled' ? (
                          <input
                            type="checkbox"
                            name={pax.Paxid}
                            value={pax.Paxid}
                            checked={isChecked(pax.Paxid)}
                            onChange={() => handleCheckboxSelection(pax)}
                          />
                        ) : (
                          '-'
                        )}
                      </span>
                      <span>
                        {pax.Title} {pax.FirstName} {pax.LastName}({pax.Type})
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="m-2 d-flex flex-column align-items-start gap-2">
              <AppTextInput
                value={requesterName}
                label="Requester Name"
                disabled
                onChange={(e) => setRequesterName(e.target.value)}
              />
              <AppNumberInput
                value={requestContactNumber}
                label="Contact Number"
                disabled
                onChange={(d) => setRequestContactNumber(d)}
              />
              <AppTextInput
                value={cancelRemarks}
                label="Remarks"
                onChange={(e) => setCancelRemarks(e.target.value)}
              />
              {/* </div> */}
              <AppButton
                onClick={handleCancel}
                disabled={selectedForCancel.length === 0}
                className="px-5"
                btnText="Cancel"
              />
            </div>
          </div>
          <Modal
            className="app-modal"
            show={showSplitPnrModal}
            size="md"
            backdrop="static"
            keyboard={false}
            onHide={() => setShowSplitPnrModal(false)}
          >
            <Modal.Body className="cancel-flight-body">
              <div className="cancel-flight-body__cancel-title">
                Are you sure?
              </div>
              <div className="fs-14 fw-400 mb-3">
                You have not selected all passenegers, so selected passengers
                will be split from this pnr
              </div>
              <div className="d-flex mt-2">
                <AppButton
                  className="flex-1 me-2"
                  btnText="Proceed"
                  onClick={handleSplitPnr}
                />
                <AppButton
                  className="flex-1 ms-2"
                  btnText="Cancel"
                  variant="secondary"
                  onClick={() => setShowSplitPnrModal(false)}
                />
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            className="app-modal"
            show={showCancelConfirmModal}
            size="md"
            backdrop="static"
            keyboard={false}
            onHide={() => setShowCancelConfirmModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title />
            </Modal.Header>
            <Modal.Body className="cancel-flight-body">
              <div className="cancel-flight-body__cancel-title">
                Total Cancellation Charges
              </div>
              <table className="table-bordered">
                <tbody>
                  <tr>
                    <td>Cancellation Charges</td>
                    <td>Total Canx Charges</td>
                    <td>Final Refund Amount</td>
                    <td>Service Charge</td>
                  </tr>
                  <tr>
                    <td>
                      {isEmpty(apiCanxChargesRef.current)
                        ? ''
                        : Math.round(apiCanxChargesRef.current)}
                    </td>
                    <td>
                      {isEmpty(totalCanxChargesRef.current)
                        ? ''
                        : Math.round(totalCanxChargesRef.current)}
                    </td>
                    <td>
                      {isEmpty(cancellationRefundAmountRef.current)
                        ? ''
                        : Math.round(cancellationRefundAmountRef.current)}
                    </td>
                    <td>
                      {isEmpty(totalRefunddAmountRef.current)
                        ? ''
                        : Math.round(totalRefunddAmountRef.current)}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="d-flex mt-2">
                <AppButton
                  className="flex-1 me-2"
                  btnText="Yes"
                  onClick={handleConfirmCancel}
                />
                <AppButton
                  className="flex-1 ms-2"
                  btnText="No"
                  variant="secondary"
                  onClick={() => setShowCancelConfirmModal(false)}
                />
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            className="app-modal"
            show={showPartialCancelFooter}
            size="md"
            backdrop="static"
            keyboard={false}
            onHide={() => setShowPartialCancelFooter(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title />
            </Modal.Header>
            <Modal.Body className="cancel-flight-body">
              <div className="cancel-flight-body__cancel-title">
                Partial Cancellation
              </div>
              <div className="fs-14 fw-600">
                Total Refund Amount is{' '}
                {formatCurrency(totalPartialCancelAmountRef.current)}
              </div>
              <div className="cancel-flight-body__cancel-description">
                Are you sure you want to cancel?
              </div>
              <div className="d-flex">
                <AppButton
                  className="flex-1 me-2"
                  btnText="Yes"
                  variant="secondary"
                  // onClick={handlePartialConfirmCancel}
                />
                <AppButton
                  className="flex-1 ms-2"
                  btnText="No"
                  onClick={() => setShowPartialCancelFooter(false)}
                />
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </section>
  );
}

export default FlightCancellation;
